import { render, staticRenderFns } from "./FormasPagamento.vue?vue&type=template&id=42b296db&scoped=true"
import script from "./FormasPagamento.vue?vue&type=script&lang=js"
export * from "./FormasPagamento.vue?vue&type=script&lang=js"
import style0 from "./FormasPagamento.vue?vue&type=style&index=0&id=42b296db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b296db",
  null
  
)

export default component.exports